import { Box } from '@mui/material';
import React from 'react';
import PersonCard from '../../../shared/Cards/PersonCard';
import SwiperComponent from '../../../shared/SwiperComponent/SwiperComponent';

const studentsPath = 'students';
const logosPath = 'studentsWork';

export default function GraduatesContent({
  data: { people = [] },
  studentsData,
  studentsWorkData,
}) {
  return (
    <Box sx={{ mx: 1, mb: 2, mt: 2 }}>
      <SwiperComponent
        hideNavigate
        slidesPerView={1.2}
        spaceBetween={16}
        breakpoints={{
          400: {
            slidesPerView: 1.4,
            spaceBetween: 4,
          },
          535: {
            slidesPerView: 1.5,
            spaceBetween: 8,
          },
          700: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1010: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1410: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        }}
        centeredSlides={false}
        slides={people.map(
          (person) =>
            function () {
              return (
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                  key={person.fullName}
                >
                  <PersonCard
                    {...person}
                    height="100%"
                    image={studentsData[`${studentsPath}/${person.photo}`]}
                    logo={
                      studentsWorkData[`${logosPath}/${person.company?.logo}`]
                    }
                  />
                </Box>
              );
            },
        )}
      />
    </Box>
  );
}
